export type DmsUploadFileRole = "recording" | "log" | "diary";

export interface DmsFileCandidate {
  name: string;
  size: number;
}

export const getFileExtension = (filename: string) => {
  const lastDotIndex = filename.lastIndexOf(".");

  if (lastDotIndex >= 0) {
    return filename.slice(lastDotIndex + 1).toLowerCase();
  }

  return "";
};

export const getDmsUploadFileRole = (filename: string): DmsUploadFileRole | null => {
  const extension = getFileExtension(filename);

  if (extension === "cdm") {
    return "recording";
  }

  if (extension === "log") {
    return "log";
  }

  if (extension === "pdf") {
    return "diary";
  }

  return null;
};

export const hasRequiredRecordingFile = (fileNames: string[]) =>
  fileNames.some((fileName) => getDmsUploadFileRole(fileName) === "recording");

export const selectLargestDmsFile = <T extends DmsFileCandidate>(files: T[]): T | undefined =>
  files
    .filter((file) => file.size > 0)
    .sort((first, second) => second.size - first.size)[0];
